import { render, staticRenderFns } from "./ProjectsMain.vue?vue&type=template&id=f16a2ee0"
import script from "./ProjectsMain.vue?vue&type=script&lang=js"
export * from "./ProjectsMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports